module.exports = __webpack_public_path__ + "img/map-pin.617f2874.svg";